import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import GuestListLayer from "../components/GuestListLayer";


const GuestListPage = () => {
  return (
    <>


        {/* Breadcrumb */}
        {/* <Breadcrumb title="Users Grid" /> */}
        <div className="d-flex justify-content-between"><h5>Guests  </h5><Breadcrumb title="Guests" /></div>

        {/* UsersListLayer */}
        <GuestListLayer />

   

    </>
  );
};

export default GuestListPage; 
